import React from 'react'
import { Button } from '../../../../components'
import PdcaBadge from '../pdcabadge/pdcabadge'
import PdcaPlanoMetaRow from '../pdcaplanometarow/pdcaplanometarow'
import './pdcaplanocard.scss'

const obterVariantGrupo = grupoCodigo => {
  if (grupoCodigo === 'G1') return 'danger'
  if (grupoCodigo === 'G2') return 'warning'
  return 'neutral'
}

const obterEscopo = (item, nls) => {
  if (item.loja_nome) return item.loja_nome
  if (item.produto_nome) return item.produto_nome
  return nls.scopeCompany
}

const obterTipoPlano = (tipoPlano, nls) => {
  const mapa = {
    diario: nls.planTypeDaily,
    semanal: nls.planTypeWeekly,
    mensal: nls.planTypeMonthly
  }

  return mapa[tipoPlano] || tipoPlano
}

const obterTextoGrupo = (grupoCodigo, nls) => {
  if (grupoCodigo === 'G1') return nls.cardGroupLate
  if (grupoCodigo === 'G2') return nls.cardGroupWaitingDecision
  return grupoCodigo
}

const obterAcoes = (ciclo, nls) => {
  const cicloAtual = (ciclo || '').toLowerCase()

  if (cicloAtual === 'plan' || cicloAtual === 'do') {
    return [
      { key: 'approve', label: nls.actionApprove, primary: true },
      { key: 'reject', label: nls.actionReject, primary: false },
      { key: 'details', label: nls.actionDetails, primary: false }
    ]
  }

  if (cicloAtual === 'check') {
    return [    
      { key: 'reject', label: nls.actionReject, primary: false },
      { key: 'details', label: nls.actionDetails, primary: false }
    ]
  }

  if (cicloAtual === 'act') {
    return [
      { key: 'act', label: nls.actionAct, primary: true },
      { key: 'details', label: nls.actionDetails, primary: false }
    ]
  }

  return [
    { key: 'details', label: nls.actionDetails, primary: false }
  ]
}

export default ({
  item,
  nls,
  badges = null,
  metaItems = null,
  actions = null,
  typeLabel = null,
  scopeText = null,
  titlePrefix = null,
  onDetalhes = () => {},
  onAgirAct = () => {},
  onApprove = () => {}
}) => {
  const grupoCodigo = item.grupoCodigo
  const tipoPlano = typeLabel || obterTipoPlano(item.tipo_plano, nls)
  const escopo = scopeText || obterEscopo(item, nls)
  const acoes = actions || obterAcoes(item.ciclo, nls)

  const metaItens = metaItems || (
    grupoCodigo === 'G1'
      ? [
          { label: nls.metaLateDays, value: item.atraso_dias },
          { label: nls.metaDaysToCriticalDelay, value: item.diasparaatrasocritico },
          { label: nls.metaPotentialImpact, value: item.impacto_potencial_plan }
        ]
      : [
          { label: nls.metaPendingDays, value: item.pendente_ha_dias },
          { label: nls.metaCheckEndDate, value: item.check_data_final },
          { label: nls.metaPotentialImpact, value: item.impacto_potencial_plan }
        ]
  )

  const badgesParaRenderizar = badges || [
    {
      key: `grupo-${grupoCodigo}`,
      variant: obterVariantGrupo(grupoCodigo),
      label: obterTextoGrupo(grupoCodigo, nls)
    },
    {
      key: `ciclo-${item.ciclo}`,
      variant: 'neutral',
      label: (item.ciclo || '').toUpperCase()
    }
  ]

  const numeroPlano = item.numeroPlano ?? item.numero_plano
  const titulo = item.titulo
  const prefixoTitulo = titlePrefix || nls.planNumber
  const planoId = item.idPlano ?? item.id ?? item.pdca_plano_id

  const handleActionClick = action => {
    if (typeof action.onClick === 'function') {
      action.onClick()
      return
    }

    if (action.key === 'details') {
      onDetalhes(planoId)
      return
    }

    if (action.key === 'act') {
      onAgirAct(planoId)
      return
    }

    if (action.key === 'approve') {
      onApprove(item)
    }
  }

  return (
    <div
  className='pdca-plano-card'
  data-cy='pdca-plan-card'
  data-cy-id={planoId}
>
      <div className='pdca-plano-card-badges'>
        {badgesParaRenderizar.map(badge => (
          <PdcaBadge key={badge.key} variant={badge.variant}>
            {badge.label}
          </PdcaBadge>
        ))}
      </div>

      <h3 className='pdca-plano-card-title'>
        {`${prefixoTitulo} ${numeroPlano} — ${titulo}`}
      </h3>

      <div className='pdca-plano-card-line'>
        {`${tipoPlano} • ${escopo}`}
      </div>

      <PdcaPlanoMetaRow itens={metaItens} />

      <div className='pdca-plano-card-actions'>
        {acoes.map(action => (
          <Button
  key={action.key}
  data-cy='pdca-plan-action'
  data-cy-key={action.key}
  data-cy-effect={action.key === 'details' ? 'read' : 'write'}
  color={action.primary ? 'primary' : undefined}
  onClick={() => handleActionClick(action)}
>
  {action.label}
</Button>
        ))}
      </div>
    </div>
  )
}